import Typo3Service from '../services/typo3.service';

const typo3versions = JSON.parse(localStorage.getItem('typo3versions'));


const initialState = {
	typo3versions: typo3versions ? typo3versions : null,
};

export const typo3 = {
	namespaced: true,
	state: initialState,
	actions: {
		fetchTypo3Versions({commit}) {
			return Typo3Service.getLatestVersions().then(
				(response) => {
					commit('fetchTypo3VersionSuccess', response);
					return Promise.resolve(typo3versions);
				},
				(error) => {
					commit('fetchTypo3Failure');
					return Promise.reject(error);
				}
			);
		},
	},
	mutations: {
		fetchTypo3VersionSuccess(state, response) {
			if (response.data.typo3Api) {
				localStorage.setItem('typo3versions', JSON.stringify(response.data.typo3Api));
				state.typo3versions = response.data.typo3Api;
			}
		},
		fetchTypo3Failure(state) {
			state.typo3versions = null;
		},
	},
};
